import { IconType } from "react-icons";
import { BiSolidDashboard } from "react-icons/bi";
import { FaHandshake, FaUsers } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom"

import { HStack, Icon, Spacer, Stack } from "@chakra-ui/react"
import { DEAL_MANAGER_NAV_OPTIONS } from "@/constants"
import { NavOption } from "@/types"
import { Text } from "../ui"

const NavItem = ({ label, isActive, onNavItemClick }: { label: string; isActive: boolean; onNavItemClick?: () => void }) => {
  const navigate = useNavigate()

  const convertUnderscoresToSpaces = (str: string) => {
    if (str === NavOption.TAX_CALCULATION) {
      return "Calculate Your Taxes";
    }
    if (str === NavOption.DEALS) {
      return "Deals";
    }
    return str
    .split("_")
    .map(
      word => word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
  }

  const getIconForLabel = (label: string): IconType => {
    switch(label) {
      case NavOption.DASHBOARD:
        return BiSolidDashboard
      case NavOption.CLIENTS:
        return FaUsers;
      case NavOption.DEALS:
        return FaHandshake;
      default:
        return FaUsers;
    }
  }

  return (
    <Stack
      p={3}
      backgroundColor={isActive ? "whiteAlpha.100" : "transparent"}
      cursor="pointer"
      _hover={{ backgroundColor: "whiteAlpha.100" }}
      onClick={() => { navigate(label.startsWith("/") ? label : `/${label}`); onNavItemClick?.() }}
    >
      <HStack>
        <Icon as={getIconForLabel(label) as React.ElementType} size="sm" color={isActive ? "white" : ""} />
        <Text fontSize="sm" fontWeight="medium" color={isActive ? "white" : "darkBlue.700"}>
          {convertUnderscoresToSpaces(label)}
        </Text>
      </HStack>
    </Stack>
  )
}

interface DealManagerNavigationProps {
  onNavItemClick?: () => void
}

export const DealManagerNavigation = ({ onNavItemClick }: DealManagerNavigationProps) => {
  const location = useLocation()
  const checkIsCurrentNavOption = (option: string) => {
    return location.pathname === (option.startsWith("/") ? option : `/${option}`)
  }

  return (
    <Stack h="100%" bg="darkBlue.200" color="white" pb={10}>
      <Text fontSize="xl" fontWeight="bold" pt={5} pb={5} pl={5} fontFamily={"body"}>
        ESO Fund Client Portal
      </Text>
      {DEAL_MANAGER_NAV_OPTIONS.map((option) => (
        <NavItem key={option} label={option} isActive={checkIsCurrentNavOption(option)} onNavItemClick={onNavItemClick} />
      ))}
      <Spacer />
    </Stack>
  )
}